// Initialize Values
export const INITIALIZE_VALUES_BOND_INFO = 'INITIALIZE_VALUES_BOND_INFO'
export const INITIALIZE_VALUES_IMPORTER = 'INITIALIZE_VALUES_IMPORTER'
export const INITIALIZE_VALUES_CARRIER_CODE = 'INITIALIZE_VALUES_CARRIER_CODE'
export const INITIALIZE_VALUES_ENTRY_TYPE = 'INITIALIZE_VALUES_ENTRY_TYPE'
export const INITIALIZE_VALUES_RECON = 'INITIALIZE_VALUES_RECON'
export const INITIALIZE_VALUES_TRANSPORTATION = 'INITIALIZE_VALUES_TRANSPORTATION'
export const INITIALIZE_VALUES_BOL = 'INITIALIZE_VALUES_BOL'
export const INITIALIZE_VALUES_DESCRIPTION_OF_MERCHANDISE = 'INITIALIZE_VALUES_DESCRIPTION_OF_MERCHANDISE'
export const CLEAR_INVOICE_METADATA = 'CLEAR_INVOICE_METADATA'
export const INITIALIZE_VALUES_DECLARATION_SECTION = 'INITIALIZE_VALUES_DECLARATION_SECTION'
export const INITIALIZE_VALUES_PSC_CHAIN = 'INITIALIZE_VALUES_PSC_CHAIN'
export const INITIALIZE_VALUES_FIELD_VALIDATION = 'INITIALIZE_VALUES_FIELD_VALIDATION'
export const INITIALIZE_WARNINGS = 'INITIALIZE_WARNINGS'
export const INITIALIZE_SERVER_WARNINGS = 'INITIALIZE_SERVER_WARNINGS';
export const CLEAR_VALIDATION_FIELD_ERROR = 'CLEAR_VALIDATION_FIELD_ERROR'
export const INITIALIZE_VALUES_LACEY_ACT = (pgaGuid) => `INITIALIZE_VALUES_LACEY_ACT_${pgaGuid}`
export const INITIALIZE_VALUES_TARGET_PGA = (pgaGuid) => `INITIALIZE_VALUES_TARGET_PGA_${pgaGuid}`
export const INITIALIZE_VALUES_TSCA = (pgaGuid) => `INITIALIZE_VALUES_TSCA_${pgaGuid}`
export const INITIALIZE_VALUES_FDA = (pgaGuid) => `INITIALIZE_VALUES_FDA_${pgaGuid}`
export const INITIALIZE_VALUES_NHTSA = (pgaGuid) => `INITIALIZE_VALUES_NHTSA_${pgaGuid}`
export const INITIALIZE_DROPDOWNS = 'INITIALIZE_DROPDOWNS'
export const INITIALIZE_SHIPID = 'INITIALIZE_SHIPID'
export const FORM_LOADED = 'FORM_LOADED'
export const FORM_VALUES = 'FORM_VALUES'
export const SET_ANY_FORM_VALUES = 'SET_ANY_FORM_VALUES'
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE'
export const INITIALIZE_VALUES_PSC = 'INITIALIZE_VALUES_PSC'

// BOLInfoActins
export const UPDATE_BOL_INFO_FIELD = 'UPDATE_BOL_INFO_FIELD'
export const UPDATE_CONTAINER_FIELD = 'UPDATE_CONTAINER_FIELD'
export const ADD_CONTAINER = 'ADD_CONTAINER'
export const REMOVE_ADDITIONAL_CONTAINER = 'REMOVE_ADDITIONAL_CONTAINER'
export const UPDATE_IT_DATE_FIELD = 'UPDATE_IT_DATE_FIELD'
export const SAVE_BOL_FIELD = 'SAVE_BOL_FIELD'
export const SAVE_BOL_OBJECT = 'SAVE_BOL_OBJECT'
export const SAVE_BOL_DATE_FIELD = 'SAVE_BOL_DATE_FIELD'
export const SAVE_CONTAINER = 'SAVE_CONTAINER'
export const UPDATE_BOL_OBJECT = 'UPDATE_BOL_OBJECT'
export const UPDATE_BOL_INFO_WARNING = 'UPDATE_BOL_INFO_WARNING'

// BondInfoActions
export const UPDATE_BOND_INFO_FIELD = 'UPDATE_BOND_INFO_FIELD'
export const UPDATE_ADDITIONAL_BOND_INFO_FIELD = 'UPDATE_ADDITIONAL_BOND_INFO_FIELD'
export const ADD_ADDITIONAL_BOND = 'ADD_ADDITIONAL_BOND'
export const REMOVE_ADDITIONAL_BOND = 'REMOVE_ADDITIONAL_BOND'

// DeclarationSectionActions
export const UPDATE_DECLARATION_SECTION_FIELD = 'UPDATE_DECLARATION_SECTION_FIELD'
export const SAVE_DECLARATION_SECTION_FIELD = 'SAVE_DECLARATION_SECTION_FIELD'

// DescriptionOfMerchandiseActions
export const UPDATE_HTS_CONTEXT = 'UPDATE_HTS_CONTEXT'
export const SAVE_LINE_ITEM_DUTIES = 'SAVE_LINE_ITEM_DUTIES'
export const UPDATE_TOTALS = 'UPDATE_TOTALS'
export const INVALIDATE_TOTALS = 'INVALIDATE_TOTALS'
export const CLEAR_TOTALS_STALE = 'CLEAR_TOTALS_STALE'
export const UPDATE_THESE_FIELDS_TOTALS = 'UPDATE_THESE_FIELDS_TOTALS'
export const ADD_HEADER_ITEM_PARTY = 'ADD_HEADER_ITEM_PARTY'
export const REMOVE_HEADER_ITEM_PARTY = 'REMOVE_HEADER_ITEM_PARTY'
export const UPDATE_MERCH_FIELD = 'UPDATE_MERCH_FIELD'
export const UPDATE_HAS_AVCVD = (merchandiseId) => `UPDATE_HAS_AVCVD_${merchandiseId}`
export const UPDATE_MERCH_OBJECT = 'UPDATE_MERCH_OBJECT'
export const UPDATE_MERCH_LINE_ITEM_FIELD = 'UPDATE_MERCH_LINE_ITEM_FIELD'
export const UPDATE_MERCH_LINE_ITEM_OBJECT = 'UPDATE_MERCH_LINE_ITEM_OBJECT'
export const UPDATE_MERCH_LINE_ITEM_PGA_OBJECT = 'UPDATE_MERCH_LINE_ITEM_PGA_OBJECT'
export const UPDATE_MERCH_LINE_ITEM_FLAG = 'UPDATE_MERCH_LINE_ITEM_FLAG'
export const UPDATE_MERCH_DUTY_ITEM_FIELD = 'UPDATE_MERCH_DUTY_ITEM_FIELD'
export const UPDATE_MERCH_DUTY_ITEM_OBJECT = 'UPDATE_MERCH_DUTY_ITEM_OBJECT'
export const ADD_DUTY_ITEM = 'ADD_DUTY_ITEM'
export const ADD_MERCHANDISE_LINE_ITEM = 'ADD_MERCHANDISE_LINE_ITEM'
export const REMOVE_DUTY_ITEM = 'REMOVE_DUTY_ITEM'
export const REMOVE_DUTY_ITEMS_NO_API = 'REMOVE_DUTY_ITEMS_NO_API'
export const REMOVE_MERCHANDISE_LINE_ITEM = 'REMOVE_MERCHANDISE_LINE_ITEM'
export const SAVE_MERCHANDISE_FIELD = 'SAVE_MERCHANDISE_FIELD'
export const SAVE_MERCHANDISE_LINE_ITEM = 'SAVE_MERCHANDISE_LINE_ITEM'
export const CLEAR_MERCHANDISE_LINE_ITEM = 'CLEAR_MERCHANDISE_LINE_ITEM'
export const SAVE_MERCH_DUTY_ITEM_TOTALS = 'SAVE_MERCH_DUTY_ITEM_TOTALS'
export const SAVE_MERCH_COMMODITY_DUTY_ITEM = 'SAVE_MERCH_COMMODITY_DUTY_ITEM'
export const SET_MERCHANDISE_LINE_ITEM_AVAILABLE_PGA = 'SET_MERCHANDISE_LINE_ITEM_AVAILABLE_PGA'
export const UPDATE_LINE_ITEM_WEIGHTS_BASED_ON_TOTAL_VALUE_AND_GROSS_WEIGHT = 'UPDATE_LINE_ITEM_WEIGHTS_BASED_ON_TOTAL_VALUE_AND_GROSS_WEIGHT'
export const SET_LINE_ITEM = 'SET_LINE_ITEM'
export const SET_TOTAL_VALUE_AND_GROSS_WEIGHT = 'SET_TOTAL_VALUE_AND_GROSS_WEIGHT'
export const ADD_ADDITIONAL_PGA = 'ADD_ADDITIONAL_PGA'
export const UPDATE_INVOICE_LINE_ITEM_FIELD = "UPDATE_INVOICE_LINE_ITEM_FIELD"
export const REMOVE_INVOICE_LINE_ITEM = "REMOVE_INVOICE_LINE_ITEM"
export const ADD_INVOICE_ITEM ="ADD_INVOICE_ITEM"

// EntryTypeActions
export const UPDATE_ENTRY_TYPE_FIELD = 'UPDATE_ENTRY_TYPE_FIELD'
export const UPDATE_SUMMARY_DATE_FIELD = 'UPDATE_SUMMARY_DATE_FIELD'
export const UPDATE_ENTRY_DATE_FIELD = 'UPDATE_ENTRY_DATE_FIELD'
export const UPDATE_FTZ_DATE_FIELD = 'UPDATE_FTZ_DATE_FIELD'
export const SAVE_ENTRY_TYPE_FIELD = 'SAVE_ENTRY_TYPE_FIELD'
export const SAVE_ENTRY_TYPE_DATE_FIELD = 'SAVE_ENTRY_TYPE_DATE_FIELD'
export const UPDATE_ENTRY_TYPE_OBJECT = 'UPDATE_ENTRY_TYPE_OBJECT'
export const UPDATE_ENTRY_TYPE_WARNING = 'UPDATE_ENTRY_TYPE_WARNING'

// FeildValidationActions
export const UPDATE_FIELD_WARNINGS = 'UPDATE_FIELD_WARNINGS'
export const UPDATE_FIELD_VALIDATION_OBJECT = 'UPDATE_FIELD_VALIDATION_OBJECT'
export const VALIDATE_COMPLETE_STORE = 'VALIDATE_COMPLETE_STORE'

// ImporterActions
export const INITIALIZE_LACEY_ACT_VALUES = 'INITIALIZE_LACEY_ACT_VALUES'
export const INITIALIZE_FDA_VALUES = 'INITIALIZE_FDA_VALUES'
export const UPDATE_ACTOR_FIELD = 'UPDATE_ACTOR_FIELD'
export const UPDATE_ACTOR_ADDRESS = 'UPDATE_ACTOR_ADDRESS'
export const UPDATE_HEADER_PARTY_FIELD = 'UPDATE_HEADER_PARTY_FIELD'
export const UPDATE_HEADER_PARTY = 'UPDATE_HEADER_PARTY'
export const ADD_HEADER_PARTY = 'ADD_HEADER_PARTY'
export const REMOVE_HEADER_PARTY = 'REMOVE_HEADER_PARTY'
export const UPDATE_HEADER_PARTY_ADDRESS = 'UPDATE_HEADER_PARTY_ADDRESS'
export const UPDATE_FIELD = 'UPDATE_FIELD'
export const UPDATE_IMPORTER_FIELD = 'UPDATE_IMPORTER_FIELD'
export const SAVE_ACTOR_NAME = 'SAVE_ACTOR_NAME'
export const SAVE_ACTOR_ADDRESS = 'SAVE_ACTOR_ADDRESS'
export const SAVE_HEADER_PARTIES = 'SAVE_HEADER_PARTIES'
export const SAVE_HEADER_PARTIES_BY_HEADER_ID = 'SAVE_HEADER_PARTIES_BY_HEADER_ID'
export const SAVE_IMPORTER = 'SAVE_IMPORTER'
export const SAVE_CONSIGNEE = 'SAVE_CONSIGNEE'
export const ADD_MANUFACTURER = 'ADD_MANUFACTURER'

// TransportationActions
export const UPDATE_RECON_FIELD = 'UPDATE_RECON_FIELD'
export const UPDATE_RECON_DATE = 'UPDATE_RECON_DATE'
export const SAVE_RECON_FIELD = 'SAVE_RECON_FIELD'
export const SAVE_RECON_DATE_FIELD = 'SAVE_RECON_DATE_FIELD'
export const UPDATE_RECON_INFO_WARNING = 'UPDATE_RECON_INFO_WARNING'

// TransportationActions
export const UPDATE_TRANSPORTATION_FIELD = 'UPDATE_TRANSPORTATION_FIELD'
export const UPDATE_TRANSPORTATION_DATE = 'UPDATE_TRANSPORTATION_DATE'
export const SAVE_TRANSPORTATION_FIELD = 'SAVE_TRANSPORTATION_FIELD'
export const SAVE_TRANSPORTATION_DATE_FIELD = 'SAVE_TRANSPORTATION_DATE_FIELD'
export const UPDATE_TRANSPORTATION_INFO_WARNING = 'UPDATE_TRANSPORTATION_INFO_WARNING'

// LaceyActActions
export const UPDATE_LACEY_ACT_FIELD = (pgaGuid) => `UPDATE_LACEY_ACT_FIELD_${pgaGuid}`
export const SAVE_LACEY_ACT_FIELD = (pgaGuid) => `SAVE_LACEY_ACT_FIELD_${pgaGuid}`
// export const COPY_LACEY_ACT_FIELD = (pgaGuid) => `COPY_LACEY_ACT_FIELD_${pgaGuid}`
export const UPDATE_PGA_ITEM_FIELD = (pgaGuid) => `UPDATE_PGA_ITEM_FIELD_${pgaGuid}`
export const SAVE_PGA_ITEM_FIELD = (pgaGuid) => `SAVE_PGA_ITEM_FIELD_${pgaGuid}`
// export const SAVE_PGA_LACEY_ITEM_FIELD_REPEATED = (pgaGuid) => `SAVE_PGA_LACEY_ITEM_FIELD_REPEATED_${pgaGuid}`
// export const ADD_PGA_ITEM = (pgaGuid) => `ADD_PGA_ITEM_${pgaGuid}`
export const UPDATE_LACEY_CONTAINER_FIELD = (pgaGuid) => `UPDATE_LACEY_CONTAINER_FIELD_${pgaGuid}`
export const ADD_LACEY_ADDITIONAL_CONTAINER = (pgaGuid) => `ADD_LACEY_ADDITIONAL_CONTAINER_${pgaGuid}`
export const REMOVE_LACEY_ADDITIONAL_CONTAINER = (pgaGuid) => `REMOVE_LACEY_ADDITIONAL_CONTAINER_${pgaGuid}`
export const SAVE_LACEY_CONTAINER = (pgaGuid) => `SAVE_LACEY_CONTAINER_${pgaGuid}`
export const TOGGLE_LACEY_ACT = (pgaGuid) => `TOGGLE_LACEY_ACT_${pgaGuid}`
export const REMOVE_REPEATED_PGA_ITEM_GROUP = (pgaGuid) => `REMOVE_REPEATED_PGA_ITEM_GROUP_${pgaGuid}`

// PGA Actions
export const UPDATE_PGA_FIELD = ({ pgaGuid, targetPGA }) => `UPDATE_${targetPGA}_FIELD_${pgaGuid}`
export const COPY_PGA_FIELD = ({ pgaGuid, targetPGA }) => `COPY_${targetPGA}_FIELD_${pgaGuid}`
export const SAVE_PGA_FIELD = ({ pgaGuid, targetPGA }) => `SAVE_${targetPGA}_FIELD_${pgaGuid}`
export const TOGGLE_PGA = ({ pgaGuid, targetPGA }) => `TOGGLE_${targetPGA}_${pgaGuid}`
export const UPDATE_REPEATED_FIELD = ({ pgaGuid, targetPGA }) => `UPDATE_REPEATED_FIELD_${targetPGA}_${pgaGuid}`
export const SAVE_REPEATED_FIELD = ({ pgaGuid, targetPGA }) => `SAVE_REPEATED_FIELD_${targetPGA}_${pgaGuid}`
export const ADD_REPEATED_ITEM_ARRAY = ({ pgaGuid, targetPGA }) => `ADD_REPEATED_ITEM_ARRAY_${targetPGA}_${pgaGuid}`
export const ADD_REPEATED_ITEM = ({ pgaGuid, targetPGA }) => `ADD_REPEATED_ITEM_${targetPGA}_${pgaGuid}`
export const REPEATED_ITEM_REPLACE_ALL = ({ pgaGuid, targetPGA }) => `REPEATED_ITEM_REPLACE_ALL_${targetPGA}_${pgaGuid}`
export const REMOVE_REPEATED_GROUP = ({ pgaGuid, targetPGA }) => `REMOVE_REPEATED_GROUP_${targetPGA}_${pgaGuid}`
export const REMOVE_REPEATED_SECTION = ({ pgaGuid, targetPGA }) => `REMOVE_REPEATED_SECTION_${targetPGA}_${pgaGuid}`
export const UPDATE_REPEATED_SUB_FIELD = ({ pgaGuid, targetPGA }) => `UPDATE_REPEATED_SUB_FIELD_${targetPGA}_${pgaGuid}`
export const SAVE_REPEATED_SUB_FIELD = ({ pgaGuid, targetPGA }) => `SAVE_REPEATED_SUB_FIELD_${targetPGA}_${pgaGuid}`
export const ADD_REPEATED_SUB_ITEM = ({ pgaGuid, targetPGA }) => `ADD_REPEATED_SUB_ITEM_${targetPGA}_${pgaGuid}`
export const REMOVE_REPEATED_SUB_GROUP = ({ pgaGuid, targetPGA }) => `REMOVE_REPEATED_SUB_GROUP_${targetPGA}_${pgaGuid}`
export const REPLACE_REPEATED_SUB_GROUP = ({ pgaGuid, targetPGA }) => `REPLACE_REPEATED_SUB_GROUP_${targetPGA}_${pgaGuid}`

export const ADD_REPEATED_SECTION = ({ pgaGuid, targetPGA }) => `ADD_REPEATED_SECTION_${targetPGA}_${pgaGuid}`

export const UPDATE_REPEATED_SUB_SUB_FIELD = ({ pgaGuid, targetPGA }) => `UPDATE_REPEATED_SUB_SUB_FIELD_${targetPGA}_${pgaGuid}`
export const SAVE_REPEATED_SUB_SUB_FIELD = ({ pgaGuid, targetPGA }) => `SAVE_REPEATED_SUB_SUB_FIELD_${targetPGA}_${pgaGuid}`
export const ADD_REPEATED_SUB_SUB_ITEM = ({ pgaGuid, targetPGA }) => `ADD_REPEATED_SUB_SUB_ITEM_${targetPGA}_${pgaGuid}`
export const REMOVE_REPEATED_SUB_SUB_GROUP = ({ pgaGuid, targetPGA }) => `REMOVE_REPEATED_SUB_SUB_GROUP_${targetPGA}_${pgaGuid}`

export const UPDATE_CONTAINER_PGA = ({ pgaGuid, targetPGA }) => `UPDATE_CONTAINER_${targetPGA}_${pgaGuid}`
export const ADD_CONTAINER_PGA = ({ pgaGuid, targetPGA }) => `ADD_CONTAINER_${targetPGA}_${pgaGuid}`
export const REMOVE_CONTAINER_PGA = ({ pgaGuid, targetPGA }) => `REMOVE_CONTAINER_${targetPGA}_${pgaGuid}`
export const SAVE_CONTAINER_PGA = ({ pgaGuid, targetPGA }) => `SAVE_CONTAINER_${targetPGA}_${pgaGuid}`

// TSCAActions
export const UPDATE_TSCA_FIELD = (pgaGuid) => `UPDATE_TSCA_FIELD_${pgaGuid}`
export const SAVE_TSCA_FIELD = (pgaGuid) => `SAVE_TSCA_FIELD_${pgaGuid}`
export const COPY_TSCA_FIELD = (pgaGuid) => `COPY_TSCA_FIELD_${pgaGuid}`
// export const TOGGLE_TSCA = (pgaGuid) => `TOGGLE_TSCA_${pgaGuid}`

// FDAActions
export const TOGGLE_FDA = (pgaGuid) => `TOGGLE_FDA_${pgaGuid}`
export const UPDATE_FDA_FIELD = (pgaGuid) => `UPDATE_FDA_FIELD_${pgaGuid}`
export const SAVE_FDA_FIELD = (pgaGuid) => `SAVE_FDA_FIELD_${pgaGuid}`
export const COPY_FDA_FIELD = (pgaGuid) => `COPY_FDA_FIELD_${pgaGuid}`

// NHTSAActions
export const TOGGLE_NHTSA = (pgaGuid) => `TOGGLE_NHTSA_${pgaGuid}`
export const UPDATE_NHTSA_FIELD = (pgaGuid) => `UPDATE_NHTSA_FIELD_${pgaGuid}`
export const SAVE_NHTSA_FIELD = (pgaGuid) => `SAVE_NHTSA_FIELD_${pgaGuid}`
export const COPY_NHTSA_FIELD = (pgaGuid) => `COPY_NHTSA_FIELD_${pgaGuid}`

export const SAVE_HEADER_REASON = 'SAVE_HEADER_REASON';
export const SAVE_LINE_REASON = 'SAVE_LINE_REASON';
export const SAVE_LINE_REASON_BULK = 'SAVE_LINE_REASON_BULK';
export const SAVE_PSC_DATA = 'SAVE_PSC_DATA';
export const UPDATE_PSC_DATA = 'UPDATE_PSC_DATA';

export const INITIALIZE_VALUES_NOTES = "INITIALIZE_VALUES_NOTES"
export const UPDATE_NOTES_ITEM_STATUS = "UPDATE_NOTES_ITEM_STATUS"
export const ADD_NOTES_ITEM ="ADD_NOTES_ITEM"

export const SAVE_INVOICE_LINE_ITEM="SAVE_INVOICE_LINE_ITEM"

export const SAVE_INVOICE_LINE_ITEM_FRIEGHT_DATA ="SAVE_INVOICE_LINE_ITEM_FRIEGHT_DATA"
export const UPDATE_ADDITION_DEDUCTION = 'UPDATE_ADDITION_DEDUCTION'
export const ADD_ADDITIONAL_DECLARATIONS = 'ADD_ADDITIONAL_DECLARATIONS'
export const DELETE_ADDITIONAL_DECLARATIONS = 'DELETE_ADDITIONAL_DECLARATIONS'
export const UPDATE_OBJ_AT_SHIPMENT_LEVEL= 'UPDATE_OBJ_AT_SHIPMENT_LEVEL'
